import React, { useState } from 'react';
import { Button, message, Tag } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import Cookies from 'universal-cookie';
import { cookieOptions } from '../../utils/cookieConfig';

const ImpersonationBanner = () => {
    const cookies = new Cookies();
    const isImpersonating = cookies.get("isImpersonating");
    const currentUser = cookies.get("userR");
    const originalUser = cookies.get("originalUserR");
    const [isHovered, setIsHovered] = useState(false);

    if (!isImpersonating || !originalUser) {
        return null;
    }

    const handleExitImpersonation = () => {
        // Get original token
        const originalToken = cookies.get("originalTokenR");

        // Restore original user
        cookies.set("userR", originalUser, cookieOptions);
        cookies.set("userRId", originalUser.id, cookieOptions);
        if (originalToken) {
            cookies.set("tokenR", originalToken, cookieOptions);
        }

        // Remove impersonation flags
        cookies.remove("isImpersonating", cookieOptions);
        cookies.remove("originalUserR", cookieOptions);
        cookies.remove("originalTokenR", cookieOptions);

        message.success(`Switched back to ${originalUser.name || originalUser.email}`);

        // Redirect back to impersonator selection page
        window.location.href = '/admin/user-impersonator';
    };

    const isDevelopment = process.env.NODE_ENV === 'development' || process.env.VITE_ENV !== 'production';
    const isProduction = process.env.VITE_ENV === 'production';

    // Color scheme: Red for production, Yellow for dev/test
    const colors = isProduction ? {
        bg: isHovered ? '#d32f2f' : '#f44336',
        bgHover: '#d32f2f',
        text: '#ffffff',
        buttonBg: '#ffffff',
        buttonText: '#f44336'
    } : {
        bg: isHovered ? '#fad133' : '#FED230',
        bgHover: '#fad133',
        text: '#1B1B1B',
        buttonBg: '#1B1B1B',
        buttonText: '#FED230'
    };

    return (
        <div
            className="impersonation-banner"
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                backgroundColor: colors.bg,
                color: colors.text,
                padding: isHovered ? '8px 24px' : '4px 24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                zIndex: 999,
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                {isDevelopment && (
                    <Tag color="orange" style={{ margin: 0, fontWeight: 600, fontSize: isHovered ? '12px' : '11px', padding: isHovered ? '2px 7px' : '1px 5px', transition: 'all 0.3s ease' }}>
                        DEV/TEST
                    </Tag>
                )}
                <span style={{ fontSize: isHovered ? '14px' : '12px', fontWeight: 600, transition: 'all 0.3s ease' }}>
                    {isHovered ? (
                        <>You are currently impersonating <strong>{currentUser?.name || currentUser?.email}</strong></>
                    ) : (
                        <>Impersonating: <strong>{currentUser?.name || currentUser?.email}</strong></>
                    )}
                </span>
            </div>
            <Button
                onClick={handleExitImpersonation}
                icon={<LogoutOutlined />}
                style={{
                    backgroundColor: colors.buttonBg,
                    color: colors.buttonText,
                    border: 'none',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    fontSize: isHovered ? '12px' : '11px',
                    padding: isHovered ? '4px 16px' : '2px 12px',
                    height: isHovered ? '32px' : '24px',
                    transition: 'all 0.3s ease',
                }}
            >
                {isHovered ? 'EXIT USER IMPERSONATION' : 'EXIT'}
            </Button>
        </div>
    );
};

export default ImpersonationBanner;